import { SVGProps } from 'react';

const SailweekNeutral = ({
  props,
  size = 64,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 64 64" fill="none" {...props}>
    <rect width="64" height="64" fill="#161616" rx="32" />
    <path
      fill="#888"
      d="M34.998 17.452s1.365-1.14 2.912-1.452c0 0 .383.263.695.67 0 0-1.971.2-3.607.782Zm-2.731 2.761s.984-1.21 1.386-1.479c0 0 1.785-1.171 5.393-1.551 0 0 .38.463.767.91 0 0-2.77-.196-7.546 2.12Zm-1.507 1.945s.42-.616.92-1.25c0 0 3.872-1.946 8.58-2.191 0 0 .407.535.628.904 0 0-5.446.396-10.128 2.537ZM30 23.275s5.986-3.016 11.52-2.748c0 0 .39.591.501.832.018.038-.223.047-.671.063-1.79.064-6.888.247-12.065 2.923l.715-1.07Zm-1.904 3.08s6.506-3.868 14.371-4.09c0 0 .204.387.445 1.016 0 0-5.25-.714-15.468 4.15l.652-1.077Zm-2.103 4.26s7.19-6.491 17.138-6.67c0 0 .258.737.393 1.496 0 0-7.902-.46-18.252 6.737l.721-1.563Zm-3.546 11.448S31 34.02 43.466 32.85c0 0-.147 1.108-.407 1.643h-.003c-.2-.01-7.988-.44-20.831 8.456l.221-.886Z"
    />
    <path
      fill="#888"
      d="M22.001 44.13s11.338-8.175 20-6.903c0 0-.907 1.7-.983 1.774l-.01-.002-.022-.005c-.551-.122-7.289-1.617-19.21 6.146l.225-1.01Zm2.3-8.99s9.265-9.355 19.409-8.665l.148 1.441s-6.05-2.114-19.902 8.382l.345-1.158Z"
    />
    <path
      fill="#888"
      d="M22.918 40.09s11.371-11.356 20.92-10.53c0 0-.019.924-.073 1.368l-.005-.001c-.206-.029-6.927-.97-21.092 10.1l.25-.937Zm-1.436 6.914s7.356-6.933 18.2-6.23l-.853.833c-.28-.055-8.59-.309-17.495 6.393l.148-.996Z"
    />
  </svg>
);

export default SailweekNeutral;
